// extracted by mini-css-extract-plugin
module.exports = {"collapse-button":"CollapseByHeight_collapse-button__F5jSE"};